export default "__VITE_ASSET__DOTS3ZBX__"